module.exports = __webpack_public_path__ + "static/media/Scene 12-14.00dbb574.jpg";